module.exports = __webpack_public_path__ + "img/gbwhatsapp-iphone.e061817a.webp";